export class ContratacionHechoIrreg {
    ncontrhiId: number;
    ncontrhiIdobrpub: string;
    ccontrhiDsc: string;
    flgSeleccionar: boolean;
    num_item: number;
    num_index: number;
    flg_nuevo = 'NO';

}
